import React from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
} from '@mui/material';
import TodaysCheckIns from '../components/TodaysCheckIns';

const DailyCheckInsPage: React.FC = () => {
  const [refreshTrigger] = React.useState(0);

  return (
    <Box>
      {/* Header */}
      {/* <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <IconButton 
            edge="start" 
            onClick={() => navigate('/dashboard')}
            sx={{ mr: 2 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <DashboardIcon sx={{ mr: 2, color: 'primary.main' }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Daily Check-ins Monitor
          </Typography>
          <IconButton 
            onClick={handleRefresh}
            color="primary"
          >
            <RefreshIcon />
          </IconButton>
        </Toolbar>
      </AppBar> */}

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ mt: 3 }}>
        <TodaysCheckIns refreshTrigger={refreshTrigger} />
        
        {/* Enhanced Instructions */}
        <Paper elevation={1} sx={{ mt: 3, p: 3 }}>
          <Typography variant="h6" color="primary" gutterBottom>
            Real-time Member Check-ins Dashboard
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 2, mt: 2 }}>
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>🔄 Live Updates:</strong> This page automatically shows all member check-ins for today in real-time
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>🔍 Search & Filter:</strong> Use the search bar to quickly find specific members by name, ID, membership type, or status
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>📊 Status Indicators:</strong> Green badges show successful entries, red badges show denied access due to expired memberships or overdue payments
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>🖨️ Print Reports:</strong> Use the print button to generate a comprehensive daily report with all check-in data
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>📄 Pagination:</strong> Navigate through large datasets easily with the pagination controls at the bottom
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>⚡ Performance:</strong> Data is optimized for quick loading and smooth interaction, even with hundreds of check-ins
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default DailyCheckInsPage;
